import { useEffect, useState, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import dtStyles from "../../../features/DataTable.module.scss";
import styles from "../../../layout/admin/Main.module.scss";
//共通コンポーネント
import SubScreenTitle from "../../../layout/admin/SubScreenTitle";
import ScreenTitle from "../../../layout/admin/ScreenTitle";
import Explanation from "../../../layout/admin/Explanation";
import DetailTable from "../../../../components/ui/AdminDetailTable";
// API
import { getDuplicateStudentList } from "../../../../services/apiStudent";

const DuplicateStudent = () => {
  //ユーザーID
  const { userId } = useParams();
  // ユーザーデータ
  const [userDataElements, setUserDataElements] = useState([]);
  // 一覧データ
  const [tableDataNmSnBd, setTableDataNmSnBd] = useState([]);
  const [tableDataNmSn, setTableDataNmSn] = useState([]);
  const [tableDataNmBd, setTableDataNmBd] = useState([]);
  const [tableDataSnBd, setTableDataSnBd] = useState([]);
  const [tableDataNm, setTableDataNm] = useState([]);
  const [tableDataSn, setTableDataSn] = useState([]);
  const [tableDataBd, setTableDataBd] = useState([]);
  const pagetop = useRef();

  const navigate = useNavigate();

  //テーブル情報
  const tableMeata = [
    { key: "login_id", label: "学生番号" },
    { key: "name", label: "氏名" },
    { key: "street_name1", label: "町名" },
    { key: "birthday", label: "生年月日" },
  ];

  const approvalStatusApporoval = 1; //承認ステータス_承認済み

  const simpleDataTable = (tableData) => {
    if (tableData.length < 1) {
      return <></>;
    }
    return (
      <div className={`${dtStyles.datatable} ${dtStyles.scrollTable} mb-5`}>
        <table className={dtStyles.responsivetable}>
          <thead>
            <tr>
              {tableMeata.map((field, i) => (
                <th key={i}>{field.label} </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableData.map((record, i) => (
              <tr key={i}>
                <td className="w-25">
                  <Link to={"/admin/student/detail/" + record.user_id}>
                    {record.login_id}
                  </Link>
                </td>
                <td className="w-25">{record.name}</td>
                <td className="w-25">{record.street_name1}</td>
                <td className="w-25">{record.birthday}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  useEffect(() => {
    (async function () {
      // 各種被りチェック
      // 検索実行
      const data = await getDuplicateStudentList(userId);

      //不正IDの場合、404として扱う
      //>>学生が取得できないOR承認済み
      if (
        Object.keys(data).length === 0 ||
        Object.keys(data.user_data).length === 0 ||
        data.user_data?.approval_status === approvalStatusApporoval
      ) {
        navigate("/admin/404");
        return;
      }

      setUserDataElements([
        {
          label: "氏名",
          value: data.user_data.name ? data.user_data.name : "（未登録）",
        },
        {
          label: "町名",
          value: data.user_data.street_name1
            ? data.user_data.street_name1
            : "（未登録）",
        },
        {
          label: "生年月日",
          value: data.user_data.birthday
            ? data.user_data.birthday
            : "（未登録）",
        },
      ]);
      if (data.nm_sn_bd) {
        setTableDataNmSnBd(data.nm_sn_bd);
      }
      if (data.nm_sn) {
        setTableDataNmSn(data.nm_sn);
      }
      if (data.nm_bd) {
        setTableDataNmBd(data.nm_bd);
      }
      if (data.sn_bd) {
        setTableDataSnBd(data.sn_bd);
      }
      if (data.nm) {
        setTableDataNm(data.nm);
      }
      if (data.sn) {
        setTableDataSn(data.sn);
      }
      if (data.bd) {
        setTableDataBd(data.bd);
      }
    })();
  }, []);

  return (
    <div className={styles.main} ref={pagetop}>
      <ScreenTitle>学生管理</ScreenTitle>
      <SubScreenTitle>学生承認　学生重複チェック</SubScreenTitle>
      <div className="mt-5">
        <Explanation>
          <span className="fw-bold">対象学生</span>
        </Explanation>
        <DetailTable elements={userDataElements}></DetailTable>
      </div>
      <div className="mt-5">
        <Explanation>
          <span className="fw-bold">重複チェック結果</span>
        </Explanation>
        <Explanation>
          氏名、町名、生年月日が同じ学生：{tableDataNmSnBd.length}件
        </Explanation>
        {simpleDataTable(tableDataNmSnBd)}
        <Explanation>
          氏名、町名が同じ学生：{tableDataNmSn.length}件
        </Explanation>
        {simpleDataTable(tableDataNmSn)}
        <Explanation>
          氏名、生年月日が同じ学生：{tableDataNmBd.length}件
        </Explanation>
        {simpleDataTable(tableDataNmBd)}
        <Explanation>
          町名、生年月日が同じ学生：{tableDataSnBd.length}件
        </Explanation>
        {simpleDataTable(tableDataSnBd)}
        <Explanation>氏名のみ同じ学生：{tableDataNm.length}件</Explanation>
        {simpleDataTable(tableDataNm)}
        <Explanation>町名のみ同じ学生：{tableDataSn.length}件</Explanation>
        {simpleDataTable(tableDataSn)}
        <Explanation>生年月日のみ同じ学生：{tableDataBd.length}件</Explanation>
        {simpleDataTable(tableDataBd)}
      </div>
    </div>
  );
};

export default DuplicateStudent;
